import { Outlet } from "react-router-dom";
import { AppShell } from "@/components/AppShell";

/** Shared shell for bottom-nav hubs (one AppShell mount across tab routes). */
export function HubsShell() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
